/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim2DiagMinRightIcon16Solid = forwardRef('ArrowDim2DiagMinRightIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M14.796 2.796a1.125 1.125 0 0 0-1.591-1.591l-3.08 3.079V2.5a1.125 1.125 0 0 0-2.25 0v4c0 .897.728 1.625 1.625 1.625h4a1.125 1.125 0 0 0 0-2.25h-1.784l3.08-3.08Z" }),
        React.createElement("path", { d: "M5.875 13.5v-1.784l-3.08 3.08a1.125 1.125 0 0 1-1.59-1.591l3.079-3.08H2.5a1.125 1.125 0 0 1 0-2.25h4c.897 0 1.625.728 1.625 1.625v4a1.125 1.125 0 0 1-2.25 0Z" })));
});
